import './App.css';
import { useState, useEffect } from 'react';

function App() {
  const [activeFilter, setActiveFilter] = useState('Show All');
  const [imageErrors, setImageErrors] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeNav, setActiveNav] = useState('home');
  const [loading, setLoading] = useState(true);

  const portfolioCards = [
    {
      id: 1,
      category: 'Web Development',
      title: 'Web Development',
      description: 'Web Development is used to build everything from static, text-based pages to complex e-commerce platforms, social networks, and dynamic web applications.',
      image: 'mobile-2.jpg',
    },
    {
      id: 2,
      category: 'Embedded Linux Solution',
      title: 'Embedded Linux Solution',
      description: 'Custom embedded Linux solutions for specialized hardware and industrial applications with optimized performance',
      image: 'int-2.jpg',
    },
    {
      id: 3,
      category: 'IoT',
      title: 'IoT',
      description: 'We specialize in the creation of \'smart\' systems by designing interrelated networks of devices embedded with software, sensors and other technologies connected to the cloud and internet',
      image: 'core-3.jpg',
    },
    {
      id: 4,
      category: 'Micro Processor Applications',
      title: 'Micro Processor Applications',
      description: 'Advanced microprocessor-based applications for embedded systems and real-time processing requirements',
      image: 'mobile-2.jpg',
    },
    {
      id: 5,
      category: 'Cloud & Desktop Applications',
      title: 'Cloud & Desktop Applications',
      description: 'We create various cloud supported and desktop applications such as designing customized dashboards, front end and back end development, utilities and more',
      image: 'mobile.jpg',
    },
    {
      id: 6,
      category: 'Mobile Applications',
      title: 'Mobile App Suite',
      description: 'Cross-platform mobile applications with native performance and seamless user experience',
      image: 'core-3.jpg',
      icon: 'mobile'
    },
    {
      id: 7,
      category: 'Low-Power',
      title: 'Low-Power',
      description: 'We design specialized low power electronics and software that are optimized for long lasting smart application performance i.e. smart watches, lights, sensors etc.',
      image: 'mobile-2.jpg',
    },
    {
      id: 8,
      category: 'CI/CD',
      title: 'CI/CD',
      description: 'We version control repositories by implementing an automated process of building, testing and packaging applications',
      image: 'int-2.jpg',
    },
    {
      id: 9,
      category: 'Firmware Development',
      title: 'Firmware Development',
      description: 'We develop firmware for various embedded systems and microcontrollers with focus on reliability and performance',
      image: 'core-3.jpg',
    },
    {
      id: 10,
      category: 'PCB Design',
      title: 'PCB Design',
      description: 'Custom PCB design services for electronic products with focus on manufacturability and cost optimization',
      image: 'mobile.jpg',
    },
    {
      id: 11,
      category: 'Embedded Software',
      title: 'Embedded Software',
      description: 'Specialized embedded software development for resource-constrained systems and real-time applications',
      image: 'mobile-2.jpg',
    },
    {
      id: 12,
      category: 'API Development',
      title: 'API Development',
      description: 'RESTful and GraphQL API development for seamless integration between systems and applications',
      image: 'int-2.jpg',
    }
  ];

  const filteredCards = activeFilter === 'Show All' 
    ? portfolioCards 
    : portfolioCards.filter(card => card.category === activeFilter);

  // Scroll detection to update active navigation
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'services', 'portfolio', 'contact'];
      const scrollPosition = window.scrollY + 150; // Offset for fixed header

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section) {
          const sectionTop = section.offsetTop;
          if (scrollPosition >= sectionTop) {
            setActiveNav(sections[i]);
            break;
          }
        }
      }

      // Check if at top of page
      if (window.scrollY < 100) {
        setActiveNav('home');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Loading screen effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Show loader for 2 seconds

    return () => clearTimeout(timer);
  }, []);

  // Lock body scroll when sidebar is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  // Show loading screen
  if (loading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
        <div className="loader-cube">
          <div className="cube">
            <div className="face front"></div>
            <div className="face back"></div>
            <div className="face right"></div>
            <div className="face left"></div>
            <div className="face top"></div>
            <div className="face bottom"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-50 via-blue-50 to-yellow-50 relative overflow-hidden">
      {/* Decorative Dots Pattern - Top Left */}
      <div className="absolute top-32 left-4 sm:left-8 z-0 opacity-30 hidden sm:block">
        <div className="grid grid-cols-4 gap-2">
          {[...Array(16)].map((_, i) => (
            <div 
              key={i}
              className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"
              style={{ animationDelay: `${i * 0.1}s` }}
            ></div>
          ))}
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 w-full px-4 sm:px-8 md:px-12 py-4 sm:py-6 flex items-center justify-between bg-white/95 backdrop-blur-md shadow-sm transition-all duration-300 z-50 animate-fadeIn">
        {/* Logo */}
        <div className="flex items-center">
          <div className="flex items-center">
            <div className="relative inline-flex items-center justify-center w-auto h-[40px] sm:h-[50px] animate-slideInLeft">
              <img 
                src='omny.png' 
                alt="omnyx Logo"
                className="h-full w-auto"
              />
            </div>
          </div>
        </div>

        {/* Navigation Links - Desktop */}
        <div className="hidden md:flex items-center space-x-6 lg:space-x-8 animate-fadeIn" style={{ animationDelay: '0.2s' }}>
          <a 
            href="#home" 
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
              setActiveNav('home');
              setMobileMenuOpen(false);
            }}
            className={`font-medium pb-1 transition-all hover:scale-105 ${
              activeNav === 'home' 
                ? 'text-black border-b-2 border-blue-600' 
                : 'text-gray-700 hover:text-black'
            }`}
          >
            Home
          </a>
          <a 
            href="#about" 
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('about')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              setActiveNav('about');
              setMobileMenuOpen(false);
            }}
            className={`font-medium pb-1 transition-all hover:scale-105 ${
              activeNav === 'about' 
                ? 'text-black border-b-2 border-blue-600' 
                : 'text-gray-700 hover:text-black'
            }`}
          >
            About
          </a>
          <a 
            href="#portfolio" 
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              setActiveNav('portfolio');
              setMobileMenuOpen(false);
            }}
            className={`font-medium pb-1 transition-all hover:scale-105 ${
              activeNav === 'portfolio' 
                ? 'text-black border-b-2 border-blue-600' 
                : 'text-gray-700 hover:text-black'
            }`}
          >
            Portfolio
          </a>
          <a 
            href="#contact" 
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              setActiveNav('contact');
              setMobileMenuOpen(false);
            }}
            className={`font-medium pb-1 transition-all hover:scale-105 ${
              activeNav === 'contact' 
                ? 'text-black border-b-2 border-blue-600' 
                : 'text-gray-700 hover:text-black'
            }`}
          >
            Contact
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-10 h-10 bg-blue-600 rounded flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-all animate-fadeIn"
          style={{ animationDelay: '0.3s' }}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <div className="grid grid-cols-2 gap-1 place-items-center">
              <div className="w-2 h-2 bg-white rounded-full"></div>
              <div className="w-2 h-2 bg-white rounded-full"></div>
              <div className="w-2 h-2 bg-white rounded-full"></div>
              <div className="w-2 h-2 bg-white rounded-full"></div>
            </div>
          )}
        </button>

        {/* Menu Icon - 2x2 Grid (Desktop) */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="hidden md:block w-10 h-10 bg-blue-600 rounded flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-all animate-fadeIn"
          style={{ animationDelay: '0.3s' }}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <div className="grid grid-cols-2 gap-1 place-items-center">
              <div className="w-2 h-2 bg-white rounded-full"></div>
              <div className="w-2 h-2 bg-white rounded-full"></div>
              <div className="w-2 h-2 bg-white rounded-full"></div>
              <div className="w-2 h-2 bg-white rounded-full"></div>
            </div>
          )}
        </button>
      </nav>

      {/* Sidebar Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 transition-opacity duration-300"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}

      {/* Sidebar Menu */}
      <div className={`fixed top-0 right-0 h-full w-80 sm:w-96 max-w-full bg-white z-50 shadow-2xl transform transition-transform duration-300 ease-in-out ${
        mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        {/* Top Bar with Close Button */}
        <div className="h-12 bg-white flex items-center justify-end px-4 border-b border-gray-200">
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="w-10 h-10 bg-blue-600 rounded flex items-center justify-center hover:bg-blue-700 transition-colors"
            aria-label="Close menu"
          >
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Sidebar Content */}
        <div className="overflow-y-auto h-[calc(100%-3rem)] px-6 py-6">
          {/* Logo */}
          <div className="mb-8">
            <div className="relative inline-flex items-center justify-center w-auto h-[50px]">
              <img 
                src='omny.png' 
                alt="Omnyx Solutions Logo"
                className="h-full w-auto"
              />
            </div>
          </div>

          {/* Navigation Links */}
          <div className="mb-8 space-y-4">
            <a 
              href="#home" 
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setActiveNav('home');
                setMobileMenuOpen(false);
              }}
              className={`block font-medium py-2 transition-all ${
                activeNav === 'home' 
                  ? 'text-black border-l-4 border-blue-600 pl-4' 
                  : 'text-gray-700 hover:text-black hover:pl-2'
              }`}
            >
              Home
            </a>
            <a 
              href="#about" 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setActiveNav('about');
                setMobileMenuOpen(false);
              }}
              className={`block font-medium py-2 transition-all ${
                activeNav === 'about' 
                  ? 'text-black border-l-4 border-blue-600 pl-4' 
                  : 'text-gray-700 hover:text-black hover:pl-2'
              }`}
            >
              About
            </a>
            <a 
              href="#portfolio" 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setActiveNav('portfolio');
                setMobileMenuOpen(false);
              }}
              className={`block font-medium py-2 transition-all ${
                activeNav === 'portfolio' 
                  ? 'text-black border-l-4 border-blue-600 pl-4' 
                  : 'text-gray-700 hover:text-black hover:pl-2'
              }`}
            >
              Portfolio
            </a>
            <a 
              href="#contact" 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setActiveNav('contact');
                setMobileMenuOpen(false);
              }}
              className={`block font-medium py-2 transition-all ${
                activeNav === 'contact' 
                  ? 'text-black border-l-4 border-blue-600 pl-4' 
                  : 'text-gray-700 hover:text-black hover:pl-2'
              }`}
            >
              Contact
            </a>
          </div>

          {/* About Us Section */}
          <div className="mb-8">
            <h3 className="text-xl font-bold text-black mb-3">About Us</h3>
            <div className="h-px bg-gray-300 mb-4"></div>
            <p className="text-gray-600 text-sm leading-relaxed">
              Omnyx Solutions is a software/technology service provider working out of Pakistan for its clients based in Europe. Our niche is the design, development and implementation of embedded systems to be utilized in a variety of fields such as medicine, security, telecom, electronics, business, robotics, networking and so much more.
            </p>
          </div>

          {/* Contact Us Section */}
          <div>
            <h3 className="text-xl font-bold text-black mb-3">Contact Us</h3>
            <div className="h-px bg-gray-300 mb-4"></div>
            
            <div className="space-y-4">
              {/* Address */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Maryland, USA
                  </p>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <a href="mailto:info@omnyxsolutions.com" className="text-gray-600 text-sm hover:text-blue-600 transition-colors">
                    info@omnyxsolutions.com
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <a href="tel:+17181234567" className="text-gray-600 text-sm hover:text-blue-600 transition-colors">
                    (718) 123 4567
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div id="home" className="container mx-auto px-4 sm:px-6 md:px-8 py-8 sm:py-12 md:py-16 relative z-10 mt-16 sm:mt-20 md:mt-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
          {/* Left Side - Text Content */}
          <div className="space-y-4 sm:space-y-5 md:space-y-6 animate-slideInLeft -mt-0 sm:-mt-[60px] md:-mt-[120px]">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold text-black leading-tight animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
              Where Ideas Become Solutions
            </h1>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed animate-fadeInUp" style={{ animationDelay: '0.6s' }}>
              We design and deliver intelligent solutions across industries, helping businesses grow, adapt, and innovate efficiently
            </p>
            <button 
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setActiveNav('services');
              }}
              className="bg-blue-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-blue-700 transition-all flex items-center gap-2 hover:scale-105 hover:shadow-lg animate-fadeInUp w-full sm:w-auto" 
              style={{ animationDelay: '0.8s' }}
            >
              Explore More <span>&gt;</span>
            </button>
          </div>

          {/* Right Side - Circular Graphic */}
          <div className="flex justify-center lg:justify-end relative animate-slideInRight">
            <div className="relative w-full max-w-[400px] sm:max-w-[500px] md:max-w-[600px] aspect-square">
              <div 
                className="absolute inset-0 rounded-full overflow-hidden bg-gradient-to-br from-blue-900 to-blue-800 shadow-2xl animate-scaleInBounce"
                style={{
                  backgroundImage: 'url(int-2.jpg)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  animationDelay: '1s'
                }}
              >
                {/* Overlay for better visibility if needed */}
                <div className="absolute inset-0 bg-blue-900/20"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <section id="about" className="bg-white py-12 sm:py-16 md:py-20 relative z-10">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
            {/* Left Side - Circular Graphic */}
            <div className="flex justify-center lg:justify-start relative animate-slideInLeft order-2 lg:order-1">
              <div className="relative w-full max-w-[350px] sm:max-w-[400px] md:max-w-[500px] aspect-square">
                <div 
                  className="absolute inset-0 rounded-full overflow-hidden bg-gradient-to-br from-blue-900 via-purple-800 to-blue-800 shadow-2xl"
                  style={{
                    backgroundImage: 'url(mobile-2.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                >
                  <div className="absolute inset-0 bg-blue-900/30"></div>
                </div>
              </div>
            </div>

            {/* Right Side - Text Content */}
            <div className="space-y-4 sm:space-y-5 md:space-y-6 relative animate-slideInRight order-1 lg:order-2">
              {/* About Us Badge */}
              <div className="flex justify-center mb-4">
                <div className="px-4 sm:px-6 py-2 rounded-full border-2 border-black inline-block">
                  <span className="text-black text-xl sm:text-2xl font-bold">About Us</span>
                </div>
              </div>

              {/* Heading */}
              <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-black leading-tight">
                Technology Service Provider
              </h2>

              {/* Description */}
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                Omnyx Solutions is a U.S.-based technology services company delivering innovative digital solutions to clients worldwide. We specialize in designing, developing, and deploying scalable technologies across cloud platforms, artificial intelligence, mobile applications, and embedded systems. Our work spans multiple industries, helping organizations modernize operations, enhance user experiences, and drive sustainable growth. Backed by modern tools and a team of experienced engineers, we focus on building reliable, future-ready solutions that turn ideas into real-world impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Let's Work Section */}
      <section className="bg-gradient-to-b from-blue-700 via-blue-600 to-white py-12 sm:py-16 md:py-20 relative z-10 mt-8 sm:mt-10 overflow-hidden">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
            {/* Left Side - Text Content */}
            <div className="space-y-6 sm:space-y-7 md:space-y-8 relative z-10 animate-slideInLeft">
              {/* Let's Work Badge */}
              <div className="mb-4 sm:mb-6 animate-fadeInUp text-center md:text-left">
                <div className="inline-block px-4 sm:px-6 py-2 rounded-full border-2 border-gray-300 bg-transparent">
                  <span className="text-white font-medium text-sm sm:text-base">Let's Work</span>
                </div>
              </div>

              {/* Main Heading */}
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-bold text-white leading-tight animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                Redefining traditional practices through technological advancement.
              </h2>

              {/* Call to Action Button */}
              <button 
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  setActiveNav('contact');
                }}
                className="px-6 sm:px-8 py-3 sm:py-4 rounded-lg border-2 border-white bg-transparent text-white font-semibold text-base sm:text-lg hover:bg-white hover:text-blue-900 transition-all duration-300 flex items-center gap-2 animate-fadeInUp w-full sm:w-auto" 
                style={{ animationDelay: '0.4s' }}
              >
                Let's Work Together <span>&gt;</span>
              </button>
            </div>

            {/* Right Side - Circular Graphic */}
            <div className="flex justify-center lg:justify-end relative animate-slideInRight">
              <div className="relative w-full max-w-[400px] sm:max-w-[500px] md:max-w-[600px] aspect-square">
                {/* Circular Graphic with Image */}
                <div className="absolute inset-0 rounded-full overflow-hidden shadow-2xl">
                  <img 
                    src="core-3.jpg" 
                    alt="Let's Work Together"
                    className="w-full h-full object-cover"
                    style={{ position: 'relative', zIndex: 10 }}
                  />
                  
                  {/* Overlay for better image visibility */}
                  <div className="absolute inset-0 bg-blue-900/10" style={{ zIndex: 5 }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Work Section */}
      <section className="bg-gray-50 py-8 sm:py-10 relative z-10">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <div className="max-w-4xl">
            {/* Our Work Badge */}
            <div className="mb-4 sm:mb-6 animate-fadeInUp text-center md:text-left">
              <div className="inline-block px-4 sm:px-6 py-2 rounded-full border-2 border-black bg-transparent">
                <span className="text-black font-bold text-xl sm:text-2xl">Our Work</span>
              </div>
            </div>

            {/* Main Heading */}
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-4 sm:mb-6 leading-tight animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              We are One Stop Solution Providers
            </h2>

            {/* Descriptive Paragraph */}
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
              Omnyx Solutions has been engaged in product development across multiple markets, taking on different roles ranging from partial involvement in specific development phases to complete end-to-end development processes. Here's a glimpse of the work we have undertaken.
            </p>
          </div>
        </div>
      </section>

      {/* Portfolio/Work Cards Section */}
      <section id="portfolio" className="bg-gray-50 pb-8 sm:pb-10 relative z-10">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          {/* Filter Navigation */}
          <div className="flex flex-wrap gap-2 sm:gap-3 md:gap-4 mb-8 sm:mb-10 md:mb-12 animate-fadeInUp">
            <button 
              onClick={() => setActiveFilter('Show All')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Show All' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Show All
            </button>
            <button 
              onClick={() => setActiveFilter('Web Development')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Web Development' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Web Development
            </button>
            <button 
              onClick={() => setActiveFilter('Embedded Linux Solution')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Embedded Linux Solution' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Embedded Linux Solution
            </button>
            <button 
              onClick={() => setActiveFilter('IoT')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'IoT' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              IoT
            </button>
            <button 
              onClick={() => setActiveFilter('Micro Processor Applications')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Micro Processor Applications' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Micro Processor Applications
            </button>
            <button 
              onClick={() => setActiveFilter('Cloud & Desktop Applications')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Cloud & Desktop Applications' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Cloud & Desktop Applications
            </button>
            <button 
              onClick={() => setActiveFilter('Mobile Applications')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Mobile Applications' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Mobile Applications
            </button>
            <button 
              onClick={() => setActiveFilter('Low-Power')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Low-Power' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Low-Power
            </button>
            <button 
              onClick={() => setActiveFilter('CI/CD')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'CI/CD' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              CI/CD
            </button>
            <button 
              onClick={() => setActiveFilter('Firmware Development')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Firmware Development' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Firmware Development
            </button>
            <button 
              onClick={() => setActiveFilter('PCB Design')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'PCB Design' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              PCB Design
            </button>
            <button 
              onClick={() => setActiveFilter('Embedded Software')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'Embedded Software' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              Embedded Software
            </button>
            <button 
              onClick={() => setActiveFilter('API Development')}
              className={`px-4 sm:px-5 md:px-6 py-2 rounded-full font-medium text-sm sm:text-base transition-all ${
                activeFilter === 'API Development' 
                  ? 'bg-blue-100 text-black' 
                  : 'text-black hover:bg-gray-200'
              }`}
            >
              API Development
            </button>
          </div>

          {/* Portfolio Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
            {filteredCards.map((card, index) => (
              <div 
                key={card.id}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 animate-fadeInUp" 
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="h-40 sm:h-44 md:h-48 bg-white flex items-center justify-center p-4 sm:p-5 md:p-6">
                  {card.logo ? (
                    <div className="text-center">
                      <div className="text-4xl font-bold text-black mb-2" style={{ fontFamily: 'sans-serif' }}>
                        {card.logo}
                      </div>
                      <div className="text-xs uppercase text-black tracking-wider">TECHNOLOGIES</div>
                    </div>
                  ) : imageErrors[card.id] ? (
                    <div className="w-full h-full flex items-center justify-center">
                      {card.icon === 'erp' && (
                        <div className="w-32 h-32 bg-gradient-to-br from-gray-300 to-gray-400 rounded-full flex items-center justify-center">
                          <svg className="w-20 h-20 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                          </svg>
                        </div>
                      )}
                      {card.icon === 'mobile' && (
                        <div className="w-32 h-32 bg-gradient-to-br from-blue-200 to-blue-300 rounded-lg flex items-center justify-center">
                          <svg className="w-20 h-20 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                          </svg>
                        </div>
                      )}
                      {card.icon === 'desktop' && (
                        <div className="w-32 h-24 bg-gradient-to-br from-blue-300 to-blue-400 rounded-full flex items-center justify-center">
                          <svg className="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v1h12v-1l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/>
                          </svg>
                        </div>
                      )}
                    </div>
                  ) : (
                    <img 
                      src={card.image} 
                      alt={card.title}
                      className="w-full h-full object-contain"
                      onError={() => setImageErrors(prev => ({ ...prev, [card.id]: true }))}
                    />
                  )}
                </div>
                <div className="p-4 sm:p-5 md:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-black mb-2">{card.title}</h3>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section - Hi, let's talk */}
      <section id="contact" className="bg-white py-12 sm:py-16 md:py-20 relative mb-6 sm:mb-8 z-10 overflow-hidden">
        {/* Background Pattern - Diagonal Lines */}
        <div className="absolute top-0 right-0 w-1/2 sm:w-1/3 h-full opacity-10 hidden sm:block">
          <div className="absolute inset-0" style={{
            backgroundImage: `repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #3b82f6 10px,
              #3b82f6 20px
            )`
          }}></div>
        </div>

        <div className="container mx-auto px-4 sm:px-6 md:px-8 relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
            {/* Left Side - Text Content */}
            <div className="space-y-6 sm:space-y-7 md:space-y-8 relative z-10 animate-slideInLeft order-2 lg:order-1">
              {/* Main Heading */}
              <h2 className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-bold text-black leading-tight animate-fadeInUp">
                Hi, let's talk
              </h2>

              {/* Descriptive Paragraph */}
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                Have an idea you want to bring to life or a product you're looking to improve? At Omnyx Solutions, we work closely with our clients to understand their goals and transform them into practical, high-quality digital solutions. Whether you're exploring new opportunities, scaling an existing platform, or solving a complex challenge, our team is here to help you move forward with confidence for every step of the way.
              </p>

              {/* Contact Information */}
              <div className="space-y-4 sm:space-y-5 md:space-y-6 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
                {/* Email */}
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-bold text-black mb-1 sm:mb-2">Email</h3>
                    <a href="mailto:info@omnyxsolutions.com" className="text-lg sm:text-xl font-bold text-black hover:text-blue-600 transition-colors break-all">
                      info@omnyxsolutions.com
                    </a>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-bold text-black mb-1 sm:mb-2">Phone</h3>
                    <div className="space-y-2">
                      <a href="tel:+17181234567" className="block text-lg sm:text-xl font-bold text-black hover:text-blue-600 transition-colors">
                        (718) 123 4567
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Circular Graphic */}
            <div className="flex justify-center lg:justify-end relative animate-slideInRight order-1 lg:order-2">
              <div className="relative w-full max-w-[350px] sm:max-w-[400px] md:max-w-[500px] aspect-square">
                <div className="absolute inset-0 rounded-full overflow-hidden bg-gradient-to-br from-blue-100 to-blue-200 shadow-2xl">
                  <img 
                    src="mobile.jpg" 
                    alt="Contact Us"
                    className="w-full h-full object-cover"
                    style={{ position: 'relative', zIndex: 10 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="bg-white py-6 sm:py-8 relative z-10 border-t border-gray-200">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-8 mb-6 sm:mb-8">
            {/* Logo Section */}
            <div className="lg:col-span-1">
              <div className="flex items-center mb-3 sm:mb-4">
                <div className="relative inline-flex items-center justify-center w-auto h-[40px] sm:h-[50px]">
                  <img 
                    src='omny.png' 
                    alt="Omnyx Solutions Logo"
                    className="h-full w-auto"
                  />
                </div>
              </div>
                <p className="text-black text-xs sm:text-sm">
                  Omnyx Solutions is a software/technology service provider working out of Pakistan for its clients based in Europe. Our niche is the design, development and implementation of embedded systems.
                </p>
            </div>

            {/* Services Section */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-black mb-3 sm:mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    Low-Power
                  </a>
                </li>
                
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    IOT
                  </a>
                </li>
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    CI/CD
                  </a>
                </li>
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    Medical Applications
                  </a>
                </li>
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    Prototyping
                  </a>
                </li>
                
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    Embedded Linux Solutions
                  </a>
                </li>
              </ul>
            </div>

            {/* Links Section */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-black mb-3 sm:mb-4">Links</h3>
              <ul className="space-y-2">
                <li>
                  <a 
                    href="#about" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('about')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a 
                    href="#services" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a 
                    href="#portfolio" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    Portfolio
                  </a>
                </li>
                <li>
                  <a 
                    href="#contact" 
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="text-black hover:text-blue-600 transition-colors text-sm"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Follow Section */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-black mb-3 sm:mb-4">Follow</h3>
              <ul className="space-y-2">
                <li>
                  <a href="https://www.linkedin.com/company/omnyxsolutions" target="_blank" rel="noopener noreferrer" className="text-black hover:text-blue-600 transition-colors text-sm flex items-center gap-2 pb-2">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/omnyxsolutions" target="_blank" rel="noopener noreferrer" className="text-black hover:text-blue-600 transition-colors text-sm flex items-center gap-2 pb-2">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/omnyxsolutions" target="_blank" rel="noopener noreferrer" className="text-black hover:text-blue-600 transition-colors text-sm flex items-center gap-2 pb-2">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                    Facebook
                  </a>
                </li>
                <li>
                  <a href="https://www.twitter.com/omnyxsolutions" target="_blank" rel="noopener noreferrer" className="text-black hover:text-blue-600 transition-colors text-sm flex items-center gap-2">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                    </svg>
                    Twitter
                  </a>
                </li>
              </ul>
            </div>

            {/* Address Section */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-black mb-3 sm:mb-4">Address</h3>
              <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                <p className="text-black">
                  Maryland, USA
                </p>
                <div>
                  <a href="mailto:info@omnyxsolutions.com" className="text-base sm:text-lg font-bold text-black hover:text-blue-600 transition-colors break-all">
                      info@omnyxsolutions.com
                    </a>
                </div>
                <div className="space-y-1">
                  <a href="tel:+17181234567" className="block text-base sm:text-lg font-bold hover:text-blue-600 text-black transition-colors">
                    (718) 123 4567
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-200 pt-4 mt-4">
            <div className="text-black text-sm sm:text-base md:text-lg text-center px-4">
              Copyright © 2026 All rights reserved by Omnyx Solutions LLC 
            </div>
          </div>
        </div>
      </footer>

      {/* Decorative Dots Pattern - Bottom Right */}
      
    </div>
  );
}

export default App;
